import React from 'react';
import { mockData } from '../mockData';
import { CheckCircle2, Clock, DollarSign } from 'lucide-react';

const StatsSection = () => {
  const icons = [CheckCircle2, Clock, DollarSign];

  return (
    <section className="py-16 bg-brand-gradient relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-1/3 translate-y-1/3"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">
            Streamlined Trademark Registration to Protect Your Brand
          </h2>
          <p className="text-emerald-50 text-lg max-w-3xl mx-auto">
            At Trademark Law Associates, we simplify the trademark registration process, offering businesses a fast, cost-effective way to secure their intellectual property.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {mockData.stats.map((stat, index) => {
            const Icon = icons[index];
            return (
              <div
                key={stat.id}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-8 text-center hover:bg-white/20 transition-all duration-300 hover:scale-105 group"
              >
                <div className="flex justify-center mb-4">
                  <div className="bg-white/20 p-4 rounded-full group-hover:bg-white/30 transition-colors">
                    <Icon className="text-white" size={32} />
                  </div>
                </div>
                <h3 className="text-4xl font-bold text-white mb-2">{stat.value}</h3>
                <p className="text-emerald-50 text-lg">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
